import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/denunciaFiscal/';

class DenunciaService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + (data ? data.token : '')
            };
        });
    }

    findAllByFiltro(idCliente, filtro) {
        return axios.get(API_URL + 'all?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers });
    }

    save(denuncia) {
        return axios.post(API_URL, JSON.stringify(denuncia),
            { headers: this.headers });
    }

    get(denunciaId) {
        return axios.get(API_URL + denunciaId, { headers: this.headers });
    }

    findAllByTipoCpfCnpjDenunciaFis(idCliente, cpfCnpj) {
        return axios.get(API_URL + 'filterContrDenunciado?idCliente=' + idCliente + '&cpfCnpj=' + cpfCnpj, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    remove(denunciaId) {
        return axios.delete(API_URL + denunciaId, { headers: this.headers });
    }

    //Manifestação
    findDadosManifestacao(idCliente, cpfCnpj, chave) {
        return axios.get(API_URL + 'dadosManifestacao?idCliente=' + idCliente + '&cpfCnpj=' + cpfCnpj + '&chave=' + chave, { headers: this.headers });
    }

}

export default new DenunciaService();